import DataSource from 'constants/sources/DataSource'

export const ADA = 'ADA'
export const AAVE = 'AAVE'
export const AMP = 'AMP'
export const APE = 'APE'
export const ARB = 'ARB'
export const AVAX = 'AVAX'
export const BCH = 'BCH'
export const BNB = 'BNB'
export const BTC = 'BTC'
export const DAI = 'DAI'
export const DASH = 'DASH'
export const DOGE = 'DOGE'
export const ENS = 'ENS'
export const ETH = 'ETH'
export const FLOW = 'FLOW'
export const GOT = 'GOT'
export const LTC = 'LTC'
export const LUNA = 'LUNA'
export const MATIC = 'MATIC'
export const NEAR = 'NEAR'
export const RBTC = 'RBTC'
export const RUNE = 'RUNE'
export const SOL = 'SOL'
export const SUSHI = 'SUSHI'
export const UNI = 'UNI'
export const USDC = 'USDC'
export const USDT = 'USDT'
export const WAVAX = 'WAVAX'
export const WBTC = 'WBTC'
export const WETH = 'WETH'
export const XPR = 'XPR'
export const ZRX = 'ZRX'
export const OP = 'OP'
export const TRX = 'TRX'

export const TOKEN_LONG_NAME = {
  ADA: 'Cardano',
  AAVE: 'Aave Token',
  AMP: 'Amp',
  APE: 'ApeCoin',
  ARB: 'Arbitrum',
  AVAX: 'Avalanche',
  BNB: 'Binance Coin',
  BTC: 'Bitcoin',
  BCH: 'Bitcoin Cash',
  DAI: 'Dai',
  DASH: 'Dash',
  DOGE: 'Dogecoin',
  ENS: 'Ethereum Name Service',
  ETH: 'Ether',
  FLOW: 'Flow',
  GOT: 'BitGo Token',
  LTC: 'Litecoin',
  LUNA: 'LUNA',
  MATIC: 'Matic Token',
  NEAR: 'Near',
  RUNE: 'THORChain ETH.RUNE',
  OP: 'Optimism',
  RBTC: 'Rootstock Bitcoin',
  SOL: 'Solana',
  SUSHI: 'SushiToken',
  UNI: 'Uniswap',
  USDC: 'USD Coin',
  USDT: 'Tether',
  WAVAX: 'Wrapped AVAX',
  WBTC: 'Wrapped BTC',
  WETH: 'Wrapped Ether',
  XPR: 'Proton',
  TRX: 'Tron',
  ZRX: '0x',
} as const

export const tokenHasLongName = (key: string): key is keyof typeof TOKEN_LONG_NAME => {
  return key in TOKEN_LONG_NAME
}

export const getTokenLongName = (token: string) => {
  const upperToken = token.toUpperCase()
  return tokenHasLongName(upperToken) ? `${TOKEN_LONG_NAME[upperToken]} (${token})` : token
}

export const getTokenName = (token: string) => {
  const upperToken = token.toUpperCase()
  return tokenHasLongName(upperToken) ? TOKEN_LONG_NAME[upperToken] : token
}

export const CHAIN_TO_TOKEN = {
  [DataSource.Arbitrum]: ARB,
  [DataSource.Avalanche]: AVAX,
  [DataSource.BinanceSmartChain]: BNB,
  [DataSource.BitcoinCash]: BCH,
  [DataSource.Bitcoin]: BTC,
  [DataSource.BitcoinIaaS]: BTC,
  [DataSource.BitGo]: GOT,
  [DataSource.Circle]: USDC,
  [DataSource.Dash]: DASH,
  [DataSource.Dogecoin]: DOGE,
  [DataSource.EthereumIaaS]: ETH,
  [DataSource.Litecoin]: LTC,
  [DataSource.Near]: NEAR,
  [DataSource.Optimism]: OP,
  [DataSource.PolygonIaaS]: MATIC,
  [DataSource.Proton]: XPR,
  [DataSource.Rootstock]: RBTC,
  [DataSource.SolanaNew]: SOL,
  [DataSource.SolanaIaaS]: SOL,
  [DataSource.Cardano]: ADA,
  [DataSource.Tron]: TRX,
}
